module.exports = __webpack_public_path__ + "pSIbFAhLWaWz2Kf3O/RDC_RED_Logo_House.svg";